import type { EmpiricalStudySurveyQuestion } from '@/types';

export const EMPIRICAL_STUDY_DECLARATION = 'Testing the study';

const LIKERT_OPTIONS_WITH_NOT_APPLICABLE = [
  { value: '1_strongly_disagree', label: '1 Strongly Disagree' },
  { value: '2_disagree', label: '2 Disagree' },
  { value: '3_somewhat_disagree', label: '3 Somewhat Disagree' },
  { value: '4_neutral', label: '4 Neutral' },
  { value: '5_somewhat_agree', label: '5 Somewhat Agree' },
  { value: '6_agree', label: '6 Agree' },
  { value: '7_strongly_agree', label: '7 Strongly Agree' },
  { value: 'not_applicable', label: 'Not applicable' }
];

export const PRE_GAME_SURVEY_QUESTIONS: EmpiricalStudySurveyQuestion[] = [
  {
    id: 'law_program_level',
    prompt: 'Are you studying law as an undergraduate (LLB), or postgraduate (JD/LLM)?',
    options: [
      { value: 'undergraduate', label: 'Undergraduate' },
      { value: 'postgraduate', label: 'Postgraduate' }
    ]
  },
  {
    id: 'law_program_year',
    prompt: 'What year of your law program are you presently in (full-time equivalent)?',
    options: [
      { value: 'year_1', label: 'Year 1' },
      { value: 'year_2', label: 'Year 2' },
      { value: 'year_3', label: 'Year 3' },
      { value: 'year_4', label: 'Year 4' },
      { value: 'year_5', label: 'Year 5' }
    ]
  },
  {
    id: 'current_subject',
    prompt: 'Which subject are you currently attending?',
    options: [
      { value: 'criminal_law', label: 'Criminal Law' },
      { value: 'lac', label: 'LAC' },
      { value: 'contract_law', label: 'Contract Law' }
    ]
  },
  {
    id: 'attitudes_confident_understanding',
    prompt: "I feel confident in my current understanding of this week's content.",
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'attitudes_motivated_class',
    prompt: "I feel motivated to engage with today's class.",
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'attitudes_active_practice_helps',
    prompt: 'I believe active practice activities (e.g. quizzes, exercises) help me learn.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'attitudes_lectures_readings_effective',
    prompt:
      'I find learning through lectures and readings an effective way to learn and understand legal concepts and ideas.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'attitudes_exercises_discussions_effective',
    prompt:
      'I find learning through exercises and discussions an effective way to learn and understand legal concepts and ideas.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'attitudes_interactive_tasks_effective',
    prompt:
      'I find learning through interactive activities such as debates and competitive tasks is an effective way to learn and understand legal concepts and ideas.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'attitudes_comfortable_digital_tools',
    prompt: 'I am comfortable using digital tools for learning purposes.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'digital_game_experience',
    prompt:
      'How would you describe your experience with educational digital games (e.g. Kahoot) as learning tools?',
    options: [
      { value: 'no_experience', label: 'No experience' },
      { value: 'very_little', label: 'Very little' },
      { value: 'some_experience', label: 'Some experience' },
      { value: 'quite_experienced', label: 'Quite experienced' },
      { value: 'very_experienced', label: 'Very experienced' }
    ]
  },
  {
    id: 'perceptions_gamification_effective',
    prompt:
      'Elements of gamification (e.g. point-scoring, challenges) are an effective way to encourage me to learn the content.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'perceptions_gamified_distraction_concern',
    prompt:
      'In a classroom environment, I am concerned that gamified learning might feel like a distraction rather than a learning activity.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'perceptions_competing_with_classmates_comfortable',
    prompt: 'I would feel comfortable competing with classmates in gamified learning.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  },
  {
    id: 'perceptions_async_gamified_learning_effective',
    prompt:
      'I think I would learn effectively through asynchronous (e.g. online activities before tutorials) gamified learning.',
    options: LIKERT_OPTIONS_WITH_NOT_APPLICABLE
  }
];

export const POST_GAME_SURVEY_QUESTIONS: EmpiricalStudySurveyQuestion[] = [
  {
    id: 'enjoyed_game',
    prompt: 'Did you enjoy the game?',
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ]
  }
];
